import { z } from "zod"

export const ValidationPresets = {
  db: {
    ulid: z.string().length(26, "ULID must be 26 characters long"),
    veryShortId: z.string().length(8, "Short ID must be 8 characters long"),
    shortId: z.string().length(22, "Short ID must be 10 characters long"),
  },
  ids: {
    agentId: z
      .string()
      .min(1, "Agent ID is required")
      .max(64, "Agent ID must be 64 characters or less")
      .regex(
        /^[a-zA-Z0-9](?:[a-zA-Z0-9._-]*[a-zA-Z0-9])?$/,
        "Use letters, numbers, -, _, . only. Must start/end with letter or number.",
      ),
  },
  strings: {
    short: z.string().max(100, "String must be less than 100 characters"),
    long: z.string().max(1000, "String must be less than 1000 characters"),
    prompt: z.string().max(20000, "Prompt must be less than 20000 characters"),
    data: z.string().max(40000000, "Data must be less than 40MB"),
    email: z
      .string()
      .email()
      .max(100, "Email must be less than 100 characters"),
    url: z.string().url().max(2000, "URL must be less than 2000 characters"),
    phone: z
      .string()
      .min(10, "Phone number must be at least 10 digits")
      .max(20, "Phone number must be less than 20 digits"),
    datetime: z.string().datetime(),
    timezone: z
      .string()
      .regex(
        /^[A-Za-z_]+\/[A-Za-z_]+$/,
        "Must be valid IANA timezone (e.g., America/Los_Angeles)",
      )
      .refine(
        (tz) => {
          try {
            Intl.DateTimeFormat(undefined, { timeZone: tz })
            return true
          } catch {
            return false
          }
        },
        { message: "Invalid IANA timezone identifier" },
      ),
  },
  numbers: {
    default: z
      .number()
      .min(-1000000, "Number must be greater than -1000000")
      .max(1000000, "Number must be less than 1000000"),
  },
  booleans: {
    default: z.boolean(),
  },
  arrays: {
    default: (elementType: z.ZodTypeAny) =>
      z.array(elementType).max(1000, "Array must have at most 1000 elements"),
  },
  records: {
    default: z.record(z.any()).refine((data) => {
      if (!data) {
        return true
      }
      const serialized = JSON.stringify(data)
      const bytes = new TextEncoder().encode(serialized).length
      return bytes < 1024 * 1024 * 10
    }, "Total object size must be less than 10MB"),
  },
}
